import { useNavigate } from "react-router-dom";
import { DisplayCardButton } from "./components/display-card-button";
import { DisplayCardStatus } from "./components/display-card-status";
import { DisplayCardSubtitle } from "./components/display-card-subtitle";
import { DisplayCardTitle } from "./components/display-card-title";
import "./display-card.scss";
import { IDisplayCardProps } from "./props";

/** It show parking lots name, and the number of available places and occupied places */
// eslint-disable-next-line @typescript-eslint/naming-convention
export function DisplayCard(props: IDisplayCardProps)
{
    const navigate = useNavigate();

    const handleButtonClick = () =>
    {
        navigate("/parking-lot/" + props.parkingLotId + "/" + props.title, { state: { id: props.parkingLotId, name: props.title } });
    };

    /**
     * Meghatározza a háttérszínt.
     * @param warningMessage Ha van, akkor warning kártya lesz látható.
     * @returns
     */
    const renderBackgroundClassName = (warningMessage?: string) => (warningMessage ? "display-card warning-display-card" : "display-card success-display-card");
    const isWarning = (props.warningMessage && props.warningMessage.length > 0) === true;

    return (
        <div className={renderBackgroundClassName(props.warningMessage)}>
            <DisplayCardTitle text={props.title} isWarning={isWarning} />
            <DisplayCardSubtitle freeParkingSpace={props.freeParkingSpace} allParkingSpace={props.allParkingSpace} />
            <DisplayCardStatus warningText={props.warningMessage} isPlaceholderData={props.isPlaceholderData} />
            <DisplayCardButton isWarning={isWarning} onClick={handleButtonClick} disabled={props.isPlaceholderData} />
        </div>
    );
}
